<template>
  <div>
    <!-- <div class="field-row">
        <input type="text" v-model="title" name="" id="" placeholder="Category name" />
    </div>
    <div class="field-row">
        <Textarea v-model="description" placeholder="description"></Textarea>
    </div>
    <div class="field-row">
        <button @click.prevent="savedata">Save</button>
    </div> -->
    <a-modal
      v-model="visible"
      :width="this.settings['isMobileView'] ? 480 : 720"
      title="Create Outward Transaction"
      onOk="handleOk"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Save</a-button>
      </template>
      <div class="row">
        <div class="col-12">
          <h4>{{ oldrecord.name }}</h4>
          <p class="mb-2">
             Product Code: <span class="font-weight-bold">{{ oldrecord.code }}</span> | Rate (₹): <span class="font-weight-bold">{{ oldrecord.selling_price }}</span> | Balance Qnty.: <span class="font-weight-bold">{{ oldrecord.product_stock == null ? 0 : oldrecord.product_stock.quantity}}</span>
          </p>
        </div>
      </div>
      <hr>
      <a-form class="mb-4" :form="form">

        <div class="row">
          <div class="col-md-4 mb-2">
            <a-form-item label="Quantity">
              <a-input-number
                style="width: 100%"
                :min="0"
                v-decorator="['quantity',{initialValue: '0'}, {rules: [{ required: true, message: 'Please input quantity!'}]}]"
                @change="handleChangeQuantity"
              />
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2">
<!--            <a-form-item label="Price">
              <a-input-number
                style="width: 100%"
                :min="0"
                v-decorator="['unitPrice',{initialValue: '0'}, {rules: [{ required: true, message: 'Please input quantity!'}]}]"
              />
            </a-form-item>-->
            <a-form-item label="Total Price">
              <a-input-number
                style="width: 100%"
                :min="0"
                v-decorator="['total_price',{initialValue: '0'}, {rules: [{ required: true, message: 'Please input total price!'}]}]"
                :disabled="true"
              />
            </a-form-item>
          </div>
          <div class="col-md-4 mb-2">
            <a-form-item label="Date" class="mb-2">
              <a-date-picker
                style="width: 100%"
                v-decorator="['transactionDate', {rules: [{ required: false, message: 'Please input date' }], initialValue: moment()},]"
                :format=dateFormat />
            </a-form-item>
          </div>
        </div>
        <!-- Select Staff -->
        <div class="row align-items-center mb-2">
          <div class="col-md-6 col-12 mb-2">
              <a-form-item label="Issued By (Staff)" class="mb-2">
                <a-select
                  show-search
                  size="default"
                  v-model="selectedIssuedBy"
                  placeholder="Search staff.."
                  optionFilterProp="children"
                  style="width: 100%"
                  @change="handleChangeIssuedBy"
                  @search="searchStaffs"
                  :filterOption="true"
                  :defaultValue="undefined"
                >
                  <a-select-option :value="0">
                    All Staffs
                  </a-select-option>
                  <template v-for="staff in staffs">
                    <a-select-option :value="staff.id" :key="staff.id">
                      {{staff.first_name + ' ' + staff.last_name}}
                    </a-select-option>
                  </template>
                </a-select>
              </a-form-item>
          </div>
          <div class="col-md-6 col-12 mb-2">
            <a-form-item label="Issued To (Staff)" class="mb-2">
              <a-select
                show-search
                size="default"
                v-model="selectedTakenBy"
                placeholder="Search Staff.."
                optionFilterProp="children"
                style="width: 100%"
                @change="handleChangeTakenBy"
                @search="searchStaffs"
                :filterOption="true"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  Select Staffs
                </a-select-option>
                <template v-for="staff in staffs">
                  <a-select-option :value="staff.id" :key="staff.id">
                    {{staff.first_name + ' ' + staff.last_name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>
        <div class="row align-items-center mb-2">
          <div class="col-md-6 col-12 mb-2">
            <a-form-item label="Issued To (Student)" class="mb-2">
              <a-select
                show-search
                size="default"
                v-model="selectedIssuedToStudent"
                placeholder="Search student.."
                optionFilterProp="children"
                style="width: 100%"
                @change="handleChangeIssuedToStudent"
                @search="searchStudents"
                :filterOption="true"
                :defaultValue="undefined"
              >
                <a-select-option :value="0">
                  All Students
                </a-select-option>
                <template v-for="student in students">
                  <a-select-option :value="student.id" :key="student.id">
                    {{student.first_name + ' ' + student.last_name}}
                  </a-select-option>
                </template>
              </a-select>
            </a-form-item>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 mb-2">
            <a-form-item label="Remark" class="mb-2">
              <a-input
                v-decorator="['remark']"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'OutwardTransaction',
  data: function () {
    return {
      form: this.$form.createForm(this),
      visible: false,
      loading: false,
      oldrecord: {},
      newrecord: {},
      selectedIssuedBy: null,
      selectedTakenBy: null,
      selectedIssuedToStudent: null,
      staffSearch: null,
      studentSearch: null,
      students: [],
      staffs: [],
      staffsMeta: {},
      staffCurrent: 1,
      staffPageSize: 10,
      staffSpinning: false,
      dateFormat: 'DD-MM-YYYY',
    }
  },
  mounted: function () {
    this.$eventBus.$on('showOutwardTransactionForm', this.showForm)
  },
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
    showForm: function(record) {
      this.visible = true
      // console.log('passed record', record)
      this.oldrecord = record
      this.getStaffs()
      setTimeout(() => {
        this.form.setFieldsValue({
          'name': record.name,
          'code': record.code,
          'balanceQuantity': record.product_stock === null ? 0 : record.product_stock.quantity,
        })
      }, 50)
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        console.log(values.transactionDate)
        if (!err) {
          this.$http
            .post(`/api/inventory/transaction/outward`, {
              product_id: this.oldrecord.id,
              quantity: values.quantity,
              price: values.unitPrice,
              total_price: values.total_price,
              date: values.transactionDate.format('YYYY-MM-DD HH:mm:ss'),
              issued_by: this.selectedIssuedBy,
              taken_by: this.selectedTakenBy,
              issued_to_student: this.selectedIssuedToStudent,
              transaction_subtype: 0,
              remark: values.remark,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onOutwardTransaction')
                this.$notification['success']({
                  message: 'Outward transaction created successfully',
                  description: 'Outward Transaction created successfully',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
              this.selectedIssuedBy = null
              this.selectedTakenBy = null
              this.selectedIssuedToStudent = null
              this.oldrecord = {}
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
    getStaffs: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/staff', {
        params: {
          limit: this.staffPageSize,
          search: this.staffSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.staffs = data.data
        this.staffSpinning = false
        this.staffsMeta = data.meta
      })
    },
    searchStaffs: function(value) {
      if (value) {
        this.staffSearch = value
        this.getStaffs(true)
      }
    },
    getStudents: function(isSearch) {
      this.staffSpinning = true

      let page = this.staffCurrent
      if (isSearch) {
        page = 1
        this.staffCurrent = 1
      }
      this.$http.get('/api/student', {
        params: {
          limit: 10,
          search: this.studentSearch,
          page: page,
        },
      }).then(({ data }) => {
        this.students = data.data
      })
    },
    searchStudents: function(value) {
      if (value) {
        this.studentSearch = value
        this.getStudents(true)
      }
    },

    handleChangeIssuedBy: function (value) {
      console.log(value)
      if (value) {
        this.selectedIssuedBy = value
      }
    },

    handleChangeTakenBy: function (value) {
      if (value) {
        this.selectedTakenBy = value
      }
    },
    handleChangeIssuedToStudent: function (value) {
      if (value) {
        this.selectedIssuedToStudent = value
      }
    },
    handleChangeQuantity: function (value) {
      if (!value) {
        value = 0
      }
      this.form.setFieldsValue({
        'total_price': value * this.oldrecord.selling_price,
      })
    },
  },
}
</script>

<style>

</style>
